function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { CardContent, StyledActionCard, Trailing, Heading, Leading, SupportiveText, ToggleWrapper } from './elements';
import { attachSubComponents, separateChildrenByType } from '../../util';
import { Icon } from '../Icon';
import { StateLayer, ToggleCore } from '../../core-components';
export const ACTIONCARD_STATE = ['enabled', 'disabled', 'readonly'];
export const ActionCard = attachSubComponents('ActionCard', ({
  variant,
  children,
  checked,
  state = 'enabled',
  ...props
}) => {
  const baseElement = getBaseElement({
    variant,
    ...props
  });
  const [leading, trailing, content] = separateChildrenByType(children, Leading, Trailing);
  return /*#__PURE__*/React.createElement(StyledActionCard, _extends({
    "data-aui": "action-card",
    $isSelected: checked,
    $state: state,
    "aria-disabled": state === 'readonly',
    disabled: state === 'disabled'
  }, props, {
    as: baseElement
  }), (variant === 'radio' || variant === 'checkbox') && /*#__PURE__*/React.createElement(ToggleWrapper, null, /*#__PURE__*/React.createElement(ToggleCore, {
    value: props.value,
    toggleType: variant,
    checked: checked,
    disabled: state !== 'enabled',
    showInteraction: false
  })), /*#__PURE__*/React.createElement(StateLayer, null), leading, /*#__PURE__*/React.createElement(CardContent, null, content), trailing, variant === 'link' && /*#__PURE__*/React.createElement(Trailing, null, /*#__PURE__*/React.createElement(Icon.SSR, {
    src: "chevron-right",
    size: "large"
  })));
}, {
  Leading,
  Heading,
  SupportiveText,
  Trailing
});
function getBaseElement({
  as,
  href,
  variant
}) {
  if (as) {
    return as;
  } else if (variant === 'radio' || variant === 'checkbox') {
    return 'label';
  } else if (href) {
    return 'a';
  } else {
    return 'button';
  }
}